module.exports = __webpack_public_path__ + "img/circle-plus-solid.6bc2290c.svg";